import React, { FC, Fragment, useEffect, useState } from 'react';
import { Loader } from '@shared/uikit/loader';
import { useClientsIndicator } from '@app/queries/hosting/useClientsIndicator';
import { Cell, Label, Pie, PieChart, ResponsiveContainer } from 'recharts';
import ValueWithSign from '@widgets/table/components/value-with-sign';
import { IHostingIndicatorsFilter } from '@pages/Hosting/Main/filter';
import PercentageMonitor from '@shared/uikit/percentage-monitor';

interface IProps {
  filter: IHostingIndicatorsFilter;
}

export const HostingIndicator: FC<IProps> = ({ filter }) => {
  const clientsIndicatorFetcher = useClientsIndicator();

  const [data, setData] = useState<any | null>(null);
  const [isCountActive, setCountActive] = useState<boolean>(true);
  const [isKwhActive, setKwhActive] = useState<boolean>(false);
  const [activePieIndex, setActivePieIndex] = useState<number | null>(null);

  useEffect(() => {
    (async () => {
      if (null === filter) return;

      const clientsData = await clientsIndicatorFetcher.fetch(filter);
      setData({
        hosting: 9,
        hosting_diff: 3.65,
      });
    })();
  }, [filter]);

  const chartData = [
    { name: 'Mining Capital', value: 55000, clients: 12 },
    { name: 'SibMine', value: 45000, clients: 12 },
    { name: 'Mining Depo', value: 35000, clients: 12 },
    { name: 'BitPartner', value: 25000, clients: 12 },
    { name: 'RusHash', value: 15000, clients: 12 },
    { name: 'Soft Mining EGGZO', value: 5000, clients: 12 },
    { name: 'Integral (Ramaz)', value: 5000, clients: 12 },
    { name: 'Mining Cluster', value: 5000, clients: 12 },
  ];

  const COLORS = [
    '#4598E6',
    '#B325F5',
    '#29A70F',
    '#18FFE4',
    '#DD1F91',
    '#FFDC18',
    '#2F18FF',
    '#18FF93',
    '#FF173A',
  ];

  return (
    <>
      <div className="flex flex-col p-[20px] w-full cursor-pointer]">
        <div className="text-[#777777] flex justify-between items-center mb-[10px]">
          <span>Хостинги | Клиенты</span>
          <div className="flex items-center gap-[3px] text-[12px]">
            <div
              onClick={() => {
                setCountActive(true);
                setKwhActive(false);
              }}
              className={` ${isCountActive ? 'bg-[#373539] text-white opacity-0' : ''} flex items-center cursor-pointer h-[20px] px-[6px] border border-[#373539] rounded-[16px] border-opacity-80 opacity-80`}
            >
              мВт
            </div>
            <div
              onClick={() => {
                setCountActive(false);
                setKwhActive(true);
              }}
              className={` ${isKwhActive ? 'bg-[#373539] text-white opacity-0' : ''} flex items-center cursor-pointer h-[20px] px-[6px] border border-[#373539] rounded-[16px] border-opacity-80 opacity-80`}
            >
              кол-во
            </div>
          </div>
        </div>

        {!clientsIndicatorFetcher.isPending && data ? (
          <>
            <div className="flex justify-between items-center mb-[10px]">
              <div className="text-[24px]">
                {data.hosting !== null && data.hosting !== undefined ? data.hosting : '-'}
              </div>
              <PercentageMonitor
                value={data.hosting_diff}
                mode={data.hosting_diff > 0 ? 'up' : 'down'}
              />
            </div>
            <div className="grid md:grid-cols-2 gap-2 items-center">
              <div className="flex flex-wrap items-center row w-[128px] text-[10px] h-fit gap-[6px]">
                {chartData.map((item, index) => (
                  <div
                    className="cursor-pointer"
                    onClick={() => setActivePieIndex(activePieIndex === index ? null : index)}
                    style={{
                      opacity: null !== activePieIndex ? (activePieIndex === index ? 1 : 0.3) : 1,
                    }}
                  >
                    <ValueWithSign
                      width="8px"
                      height="8px"
                      gap="3px"
                      value={item.name}
                      colorNumber={COLORS[index % COLORS.length]}
                    />
                  </div>
                ))}
              </div>
              <div className="relative">
                <PieChart height={120} width={120}>
                  <Pie
                    data={chartData}
                    dataKey="value"
                    stroke="none"
                    startAngle={0}
                    endAngle={-360}
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    innerRadius={40}
                    outerRadius={60}
                  >
                    {chartData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                </PieChart>
                {null !== activePieIndex ? (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      position: 'absolute',
                      width: '160px',
                      top: '50%',
                      left: 0,
                      background: 'black',
                      transform: 'translateY(-50%)',
                      padding: '5px',
                      marginLeft: '-20px',
                      borderRadius: '10px',
                      fontSize: '10px',
                    }}
                  >
                    <div className="flex justify-between">
                      <ValueWithSign
                        width="8px"
                        height="8px"
                        gap="3px"
                        value={`${chartData[activePieIndex].name}`}
                        color="bg-[#4598E6]"
                      />
                      <div className="whitespace-nowrap">{chartData[activePieIndex].value} МВт</div>
                    </div>
                    <div className="flex justify-between">
                      <ValueWithSign
                        width="5px"
                        height="5px"
                        gap="3px"
                        value={`Клиенты`}
                        color="bg-[#4598E6]"
                      />
                      <div>{chartData[activePieIndex].clients}</div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </>
        ) : (
          <Loader size={45} loading={true} padding="9px" />
        )}
      </div>
    </>
  );
};
